import BackDrop from "@components/common/BackDrop";
import ExitButton from "@components/icons/ExitButton";
import useFocus from "@hooks/useFocus";

interface IViewAllLayoutProps {
  title: string;
  onCloseHandler: () => void;
  children: JSX.Element | JSX.Element[];
}

function ViewAllLayout({
  title,
  onCloseHandler,
  children,
}: IViewAllLayoutProps): JSX.Element {
  const focusRef = useFocus();

  return (
    <>
      <BackDrop isDark={true} closeModalHandler={onCloseHandler} />
      <div
        tabIndex={0}
        ref={focusRef}
        className="fixed inset-0 z-[100] mx-auto mt-6 flex h-[calc(100%-3rem)] w-[90%] max-w-screen-desktop flex-col rounded-3xl bg-white pb-5 focus:outline-none"
      >
        <div className="flex w-full flex-row justify-between pl-28 pr-6 pt-6 pb-6">
          <h3 className="my-auto bg-white text-h3 font-semibold">{title}</h3>
          <ExitButton onClick={onCloseHandler} />
        </div>
        <div className="scrollbar flex h-full flex-col gap-10 overflow-y-auto px-28">
          {children}
        </div>
      </div>
    </>
  );
}

export default ViewAllLayout;
